module.exports = __webpack_public_path__ + "static/media/crane.27e54176.svg";